import apiFetch, { handleApiFetchError } from '@scale/frontend-lib/api-fetch';
import { useQuery, UseQueryResult } from 'react-query';
import { ChatTaskToolDefinition } from '@scale/shared/types/params/textcollection';

type ChatTaskToolsSchemasInput = {
  toolIds: string[];
};

type ChatTaskToolsSchemasOutput = {
  toolDefinitions: Record<string, ChatTaskToolDefinition>;
};

export const useGetChatTaskToolsSchemas = (
  input: ChatTaskToolsSchemasInput,
): UseQueryResult<ChatTaskToolsSchemasOutput> => {
  const resp = useQuery<ChatTaskToolsSchemasOutput>(
    ['useGetChatTaskToolsSchemas', ...Object.values(input)],
    async () => {
      return getChatTaskToolsSchemas(input);
    },
    {
      suspense: false,
    },
  );
  return resp;
};

const getChatTaskToolsSchemas: (
  input: ChatTaskToolsSchemasInput,
) => Promise<ChatTaskToolsSchemasOutput> = async input => {
  try {
    const response = await apiFetch(null, `internal/genai/getChatToolsSchemas`, {
      method: 'POST',
      body: { toolIds: input.toolIds },
    });
    return response;
  } catch (e) {
    handleApiFetchError(e);
    // Task doesn't exist
    return undefined;
  }
};
